import { customCell } from '@components/table/customCell';
import { Chip } from '@servicetitan/anvil2';
import { BodyText, TableCellProps } from '@servicetitan/design-system';
import { FC } from 'react';
import styles from './CampaignCell.module.css';

export const CampaignCell: FC<TableCellProps> = customCell((props) => {
  const { dataItem } = props;
  const { campaignName, loading } = dataItem;

  if (loading) {
    return <BodyText size='small'>{campaignName}</BodyText>;
  }

  return (
    <BodyText size='small'>
      {campaignName && (
        <Chip label={campaignName} className={styles.campaignName} />
      )}
    </BodyText>
  );
});
